import { DealCardSkeleton } from "./DealCardSkeleton";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "~/components/ui/carousel";

interface DealCarouselSkeletonProps {
  count?: number;
}

export function DealCarouselSkeleton({ count = 10 }: DealCarouselSkeletonProps) {
  return (
    <section>
      <div className="group">
        <Carousel
          opts={{
            align: "start",
            loop: false,
            dragFree: true,
            containScroll: "trimSnaps",
            duration: 20,
            watchResize: false,
            watchSlides: false,
          }}
          className="relative w-full"
        >
          <CarouselContent className="-ml-2 md:-ml-4">
            {Array.from({ length: count }).map((_, index) => (
              <CarouselItem
                key={`skeleton-${index}`}
                className="basis-1/2 pl-2 md:basis-1/3 md:pl-4 lg:basis-1/4 xl:basis-1/5"
              >
                <DealCardSkeleton />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious
            variant="carouselNav"
            size="icon"
            customPosition={true}
            className="absolute top-1/3 -left-4 z-10 inline-flex size-8 -translate-y-1/2 disabled:hidden"
          />
          <CarouselNext
            variant="carouselNav"
            size="icon"
            customPosition={true}
            className="absolute top-1/3 -right-4 z-10 inline-flex size-8 -translate-y-1/2 disabled:hidden"
          />
        </Carousel>
      </div>
    </section>
  );
}
